var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 20,
    viewBox: "0 0 123 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96389 0.170898L0.272949 19.5874H2.5109L8.94108 3.35445L15.3712 19.5874H17.6091L17.4515 19.2092L9.91821 0.170898H7.96389Z",
    fill: "#363ED3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9412 14.5131C9.89862 14.5131 10.6748 13.7369 10.6748 12.7795C10.6748 11.822 9.89862 11.0459 8.9412 11.0459C7.98372 11.0459 7.20752 11.822 7.20752 12.7795C7.20752 13.7369 7.98372 14.5131 8.9412 14.5131Z",
    fill: "#0BCB47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5205 19.5876H25.0162C23.125 19.5876 21.7066 19.0203 20.7294 17.917C19.8154 16.8454 19.5947 15.553 19.5947 14.639V2.25146H21.7066V14.639C21.7066 16.5301 22.8098 17.5073 25.0162 17.5073H25.5205V19.5876Z",
    fill: "#363ED3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5205 5.71826H17.8926V7.79862H25.5205V5.71826Z",
    fill: "#363ED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0994 5.71826H29.019V19.5872H31.0994V5.71826Z",
    fill: "#363ED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0598 3.63813C31.0172 3.63813 31.7934 2.86196 31.7934 1.90451C31.7934 0.947063 31.0172 0.170898 30.0598 0.170898C29.1023 0.170898 28.3262 0.947063 28.3262 1.90451C28.3262 2.86196 29.1023 3.63813 30.0598 3.63813Z",
    fill: "#0BCB47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1206 0.170898H46.04V19.5874H48.1206V0.170898Z",
    fill: "#363ED3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8393 19.934C36.8362 19.934 33.5581 16.6559 33.5581 12.6528C33.5581 8.64975 36.8362 5.37158 40.8393 5.37158C44.8426 5.37158 48.1206 8.64975 48.1206 12.6528C48.1206 16.6559 44.8426 19.934 40.8393 19.934ZM40.8393 7.45193C37.971 7.45193 35.6385 9.78444 35.6385 12.6528C35.6385 15.5211 37.971 17.8536 40.8393 17.8536C43.7078 17.8536 46.04 15.5211 46.04 12.6528C46.04 9.78444 43.7078 7.45193 40.8393 7.45193Z",
    fill: "#363ED3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6718 19.934C53.6687 19.934 50.3906 16.6559 50.3906 12.6528C50.3906 8.64975 53.6687 5.37158 57.6718 5.37158C61.6749 5.37158 64.9534 8.64975 64.9534 12.6528C64.9534 16.6559 61.7062 19.934 57.6718 19.934ZM57.6718 7.45193C54.8034 7.45193 52.4708 9.78444 52.4708 12.6528C52.4708 15.5211 54.8034 17.8536 57.6718 17.8536C60.5402 17.8536 62.8728 15.5211 62.8728 12.6528C62.8728 9.78444 60.5402 7.45193 57.6718 7.45193Z",
    fill: "#363ED3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6211 19.5876H73.1166C71.2253 19.5876 69.8067 19.0203 68.8301 17.917C67.9155 16.8454 67.6948 15.553 67.6948 14.639V2.25146H69.7755V14.639C69.7755 16.5301 70.8784 17.5073 73.0847 17.5073H73.5892V19.5876H73.6211Z",
    fill: "#363ED3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6202 5.71826H65.9927V7.79862H73.6202V5.71826Z",
    fill: "#363ED3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.163 12.6528C108.163 16.6559 111.441 19.934 115.444 19.934C118.616 19.934 121.301 17.9078 122.304 15.0962H120.034C119.159 16.7358 117.43 17.8536 115.444 17.8536C112.576 17.8536 110.243 15.5211 110.243 12.6528C110.243 9.78444 112.576 7.45193 115.444 7.45193C118.251 7.45193 120.544 9.68479 120.641 12.4677C120.644 12.5291 120.645 13.7549 120.645 13.8168H122.725C122.725 13.7549 122.724 12.5292 122.723 12.4677C122.624 8.54917 119.385 5.37158 115.444 5.37158C111.441 5.37158 108.163 8.64975 108.163 12.6528Z",
    fill: "#363ED3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.409 2.25146H105.904C104.013 2.25146 102.595 2.8188 101.618 3.92201C100.704 4.9937 100.483 6.28604 100.483 7.20009V19.5876H102.563V7.20009C102.563 5.30892 103.666 4.33177 105.873 4.33177H106.377V2.25146H106.409Z",
    fill: "#363ED3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.409 9.92753H98.7808V7.84717H106.409V9.92753Z",
    fill: "#363ED3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.235 13.8172H109.868V11.6851H122.235V13.8172Z",
    fill: "#363ED3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1577 5.71826H93.0776V19.5872H95.1577V5.71826Z",
    fill: "#363ED3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.118 3.63813C95.0754 3.63813 95.8516 2.86196 95.8516 1.90451C95.8516 0.947063 95.0754 0.170898 94.118 0.170898C93.1605 0.170898 92.3843 0.947063 92.3843 1.90451C92.3843 2.86196 93.1605 3.63813 94.118 3.63813Z",
    fill: "#0BCB47"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7802 19.6394H89.2757C87.3844 19.6394 85.9664 19.072 84.9892 17.9688C84.0752 16.8971 83.8545 15.6048 83.8545 14.6907V2.30322H85.9346V14.6907C85.9346 16.5819 87.038 17.5591 89.2444 17.5591H89.7489V19.6394H89.7802Z",
    fill: "#363ED3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7654 19.8432C79.7228 19.8432 80.4991 19.067 80.4991 18.1095C80.4991 17.1521 79.7228 16.376 78.7654 16.376C77.808 16.376 77.0317 17.1521 77.0317 18.1095C77.0317 19.067 77.808 19.8432 78.7654 19.8432Z",
    fill: "#0BCB47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLife);
export default __webpack_public_path__ + "static/media/icon-life.9a8b14874b45df8b8f93193d908ef4b5.svg";
export { ForwardRef as ReactComponent };